import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { TemplatesLink } from 'utils/link';
import DeleteMutation from 'mutations/template/delete';
import Confimation from 'components/form/confirmation';

const DeleteButton = ({ template, space }) => {
  const setInfo = useInfo();
  const setError = useError();
  const navigate = useNavigate();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: () => {
      setInfo('info.template.deleted');
      navigate(TemplatesLink());
    },
    onError: () => {
      setError('error.template.delete');
    },
  });

  return (
    <Confimation
      title={<FormattedMessage id="header.template.delete" />}
      description={<FormattedMessage id="confirmation.template.delete" />}
      onClick={() => {
        deleteMutation({ variables: { id: template.id } });
      }}
    >
      <Button color="error" variant="outlined" disabled={deleteMutationData.loading || !space.adminRole}>
        <FormattedMessage id="button.delete" />
      </Button>
    </Confimation>
  );
};

export default DeleteButton;
